import { render, staticRenderFns } from "./CircularPlasticBadge.vue?vue&type=template&id=55309cce&scoped=true&"
import script from "./CircularPlasticBadge.vue?vue&type=script&lang=js&"
export * from "./CircularPlasticBadge.vue?vue&type=script&lang=js&"
import style0 from "./CircularPlasticBadge.vue?vue&type=style&index=0&id=55309cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55309cce",
  null
  
)

component.options.__file = "CircularPlasticBadge.vue"
export default component.exports